import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { PanelComponent } from '../../core/panels/panel.component';
import { TabPanelComponent } from '../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../core/panels/tab-panel/tab.component';
import { FilterSearchComponent } from '../filter-search/filter-search.component';
import { RecentClaimsComponent } from '../recent-claims/recent-claims.component';
import { SearchComponent } from '../search/search.component';
import { WatchlistComponent } from '../watchlist/watchlist.component';
import { ClaimListComponent } from '../claim-list/claim-list.component';
import { HomeCardComponent } from '../../home/home-card.component';

@Component({
  selector: 'app-view-landing',
  imports: [
    TabComponent,
    TabPanelComponent,
    PanelComponent,
    CommonModule,
    SearchComponent,
    WatchlistComponent,
    RecentClaimsComponent,
    FilterSearchComponent,
    ClaimListComponent,
    HomeCardComponent,
  ],
  template: `
    <div class="tw-max-w-[1300px] tw-px-4 sm:tw-px-8 tw-py-4">
      <app-panel [showExpand]="false">
        <ng-template #header>
          <h1>View</h1>
        </ng-template>

        <div class="tw-grow tw-w-full tw-justify-center">
          <app-home-card type="Large">
            <div class="tw-pb-8 tw-w-full tw-min-w-0">
              <app-tab-panel
                [value]="tab"
                [lazy]="true"
                activeTabQueryParam="tab"
                (valueChange)="onChange($event)"
              >
                @if (hasClaimSearchAccess) {
                  <app-tab label="Claim search" value="search">
                    <ng-template #content>
                      <app-search />
                    </ng-template>
                  </app-tab>
                }
                @if (hasReportsModule || hasFiltersAccess) {
                  <app-tab label="Filter search" value="filter">
                    <ng-template #content>
                      <app-filter-search />
                    </ng-template>
                  </app-tab>
                }
                <app-tab label="History" value="history">
                  <ng-template #content>
                    <app-recent-claims (searchClick)="tab = 'search'" />
                  </ng-template>
                </app-tab>
                <app-tab label="Watchlist" value="watchlist">
                  <ng-template #content>
                    <app-watchlist (searchClick)="tab = 'search'" />
                  </ng-template>
                </app-tab>
                @if (hasClaimListAccess) {
                  <app-tab label="Claim list" value="claim-list">
                    <ng-template #content>
                      <app-claim-list />
                    </ng-template>
                  </app-tab>
                }
              </app-tab-panel>
            </div>
          </app-home-card>
        </div>
      </app-panel>
    </div>
  `,
  styles: ``,
})
export class ViewLandingComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  private route = inject(ActivatedRoute);

  tab = 'history';
  hasReportsModule = false;
  hasFiltersAccess = false;
  hasClaimListAccess = false;
  hasClaimSearchAccess = false;

  onChange(event: any) {
    this.tab = event;
  }

  ngOnInit(): void {
    const isSpecificClaimUser = this.session.isSpecificClaimUser;
    this.hasReportsModule =
      !isSpecificClaimUser && this.session.authorize('ReportsModule');
    this.hasFiltersAccess =
      !isSpecificClaimUser && this.session.authorize('FiltersModule');
    this.hasClaimListAccess = isSpecificClaimUser;
    this.hasClaimSearchAccess = !isSpecificClaimUser;
    this.setTabFromRoute();
    this.syncDefaultTabToQueryString();
    this.dispose.subs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/view')) {
          this.setTabFromRoute();
          this.syncDefaultTabToQueryString();
        }
      }
    });
  }

  setTabFromRoute() {
    const tabParam = this.route.snapshot.queryParamMap.get('tab');
    // this code was defaulting to history. This causes issues
    // with breadcrumbs back to view screen.
    if (tabParam) {
      this.tab = tabParam;
    }
  }

  /** When no tab param is in the URL, set ?tab=... so the URL reflects the active (default) tab. */
  private syncDefaultTabToQueryString(): void {
    if (this.route.snapshot.queryParamMap.has('tab')) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: this.tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
